import { Component, Injector } from '@angular/core';

import { DtoComponent, createDtoProperties } from '@mango/core';
import { Alert } from './alert';
import { AlertService } from './alert.service';

@Component({
    selector: 'dla-app-alert',
    templateUrl: './alert.component.html'/*,
    styleUrls: ['./alert.component.css']*/
})
export class AlertComponent extends DtoComponent<Alert> {
    properties = createDtoProperties<Alert>([
        'title',
        'message',
        'date',
        'type',
        'expiringDate',
        {'receivedBy': ['id']}
    ]);

    constructor(
        service: AlertService,
        injector: Injector) {
        super(injector, service, Alert);
    }

    ngOnInit() {
        super.ngOnInit();

        this.handleRoute("id");
    }
}
